const upsertCallStatus = (existingCallStatuses, id, status, errorMessage, validationErrors, resultObject) => {
    const index = existingCallStatuses.findIndex(element => element.id === id);
    if (index === -1) {
        return [
            ...existingCallStatuses,
            {
                id: id,
                status: status,
                errorMessage: errorMessage,
                validationErrors: validationErrors,
                resultObject: resultObject,
            },
        ];
    }
    return existingCallStatuses.map((callStatus, i) => {
        if (i === index) {
            return {
                id: callStatus.id,
                errorMessage: errorMessage,
                status: status,
                validationErrors: validationErrors,
                resultObject: resultObject,
            };
        }
        return callStatus;
    });
};
export const apiStateUpdateCallStatusReducer = (apiState, action) => (Object.assign(Object.assign({}, apiState), { callStatuses: upsertCallStatus(apiState.callStatuses, action.payload.id, action.payload.status, action.payload.errorMessage, action.payload.validationErrors, action.payload.resultObject) }));
//# sourceMappingURL=reducer.js.map